import BigNumber from 'bignumber.js'
import { BIG_ONE, BIG_ZERO } from 'utils/bigNumber'
import { BLOCK_TIME } from 'config'
import masterchefABI from 'config/abi/ZenMaster.json'
import slaveFarmABI from 'config/abi/slaveFarmABI.json'
import erc20 from 'config/abi/erc20.json'
import { getMasterChefAddress } from 'utils/addressHelpers'
import multicall from 'utils/multicall'

const fetchFarmsRewardsData = async (farms) => {
  const farmsWithRewardData = JSON.parse(JSON.stringify(farms));

  // Get the the master reward controller, 
    // the reward token, 
    // the rewards distribution rate and 
    // the addresseses of any slave farms from the Farm Master
  const calls = [
    {address: getMasterChefAddress(), name: 'rewardsController',},
    {address: getMasterChefAddress(), name: 'rewardToken',},
    {address: getMasterChefAddress(), name: 'rewardsPerBlock',},
    {address: getMasterChefAddress(), name: 'startBlock',},
    {address: getMasterChefAddress(), name: 'getSlaveFarms',},
  ]
  const [rewardsController, rewardToken, rewardsPerBlock, rewardStartBlock, rawSlaveFarmAddresses]  = await multicall(masterchefABI, calls)

  const slaveFarmAddresses = rawSlaveFarmAddresses[0]

  // Multicall to fetch data from each slave farm contract
  const slaveCalls = slaveFarmAddresses.flatMap((address) => [
    { address, name: 'rewardsController' },
    { address, name: 'rewardToken' },
    { address, name: 'getRewardsPerSecond' },
    { address, name: 'startBlock' },
    { address, name: 'isCommunityControl' },
  ]);

  const slaveResults = await multicall(slaveFarmABI, slaveCalls)

  const slaveControllers = [];
  const slaveRewardTokens = [];
  const slaveRewardsPerSecond = [];
  const slaveRewardStartBlock = [];
  const isCommunityControl = [];

  for (let i = 0; i < slaveResults.length; i += 5) {
    slaveControllers.push(slaveResults[i]);
    slaveRewardTokens.push(slaveResults[i + 1]);
    slaveRewardsPerSecond.push(slaveResults[i + 2]);
    slaveRewardStartBlock.push(slaveResults[i + 3]);
    isCommunityControl.push(slaveResults[i + 4]);
  }

  // Call to get balance of main reward tokens in FarmMaster
  const erc20Calls = [
    { address: rewardToken[0], name: 'symbol' },
    { address: rewardToken[0], name: 'balanceOf', params: [rewardsController[0]] },
  ];
  // Loop through slave farm reward controllers and get their balance of associated reward tokens
  slaveControllers.forEach((controller, index) => {
    erc20Calls.push(
      { address: slaveRewardTokens[index][0], name: 'symbol' },
      { address: slaveRewardTokens[index][0], name: 'balanceOf', params: [controller[0]] }
    );
  });

  const erc20Results = await multicall(erc20, erc20Calls)

  const rewardTokenSymbols = [];
  const rewardControllerBalances = [];  
  for (let i = 0; i < erc20Results.length; i += 2) {
    rewardTokenSymbols.push(erc20Results[i]);       // Symbol is at the even index
    rewardControllerBalances.push(erc20Results[i + 1]);  // Balance is at the odd index
  }

  const rewardPerSecond = rewardsPerBlock ? new BigNumber(rewardsPerBlock).div(BLOCK_TIME) : BIG_ZERO

 // const slaveRewardsPerSecond = slaveRewardsPerBlock.map(reward => reward) // ? new BigNumber(reward) : BIG_ZERO);

  // now iterate through farms and for each farm update or add the slaveFarms?: slaveFarmData[] 
  const existingSlaveFarms = farmsWithRewardData[0].slaveFarms ? farmsWithRewardData[0].slaveFarms.length : 0

  for (let i = 0; i < farmsWithRewardData.length; i++) {
    farmsWithRewardData[i].isCommunity = true;
    farmsWithRewardData[i].rewardTokenAddress = rewardToken
    farmsWithRewardData[i].rewardTokenSymbol = rewardTokenSymbols[0]
    farmsWithRewardData[i].rewardPerSecond = rewardPerSecond.toString();
    farmsWithRewardData[i].rewardTokenBalance = rewardControllerBalances[0].toString();
    farmsWithRewardData[i].rewardStartBlock = rewardStartBlock[0].toString();

    for (let j =0; j < existingSlaveFarms; j++) {
      // in here update existing slave farms
      farmsWithRewardData[i].slaveFarms[j].slaveFarmAddress = slaveFarmAddresses[j] || farmsWithRewardData[i].slaveFarms[j].slaveFarmAddress;
      farmsWithRewardData[i].slaveFarms[j].rewardControllers = slaveControllers[j][0] || farmsWithRewardData[i].slaveFarms[j].rewardControllers;
      farmsWithRewardData[i].slaveFarms[j].rewardTokenAddress = slaveRewardTokens[j][0] || farmsWithRewardData[i].slaveFarms[j].rewardTokenAddress;
      farmsWithRewardData[i].slaveFarms[j].rewardTokenSymbol = rewardTokenSymbols[j+1][0] || farmsWithRewardData[i].slaveFarms[j].rewardTokenSymbol;
      farmsWithRewardData[i].slaveFarms[j].rewardsPerSecond = ((new BigNumber (slaveRewardsPerSecond[j].toString())).times(1e14)).toString() || farmsWithRewardData[i].slaveFarms[j].rewardsPerSecond;
      farmsWithRewardData[i].slaveFarms[j].rewardTokenBalance = rewardControllerBalances[j+1].toString() || farmsWithRewardData[i].slaveFarms[j].rewardTokenBalance;
      farmsWithRewardData[i].slaveFarms[j].rewardStartBlock = slaveRewardStartBlock[j].toString() || farmsWithRewardData[i].slaveFarms[j].rewardStartBlock;
      farmsWithRewardData[i].slaveFarms[j].isCommunityControl = isCommunityControl[j] !== undefined ? isCommunityControl[j][0] : farmsWithRewardData[i].slaveFarms[j].isCommunityControl;
    }
    for (let j = existingSlaveFarms; j < slaveFarmAddresses.length; j++) {
      // in here initialize new slave farms
      const newSlave = {
        slaveFarmAddress: slaveFarmAddresses[j],
        rewardControllers: slaveControllers[j][0],
        rewardTokenAddress: slaveRewardTokens[j][0],
        rewardTokenSymbol: rewardTokenSymbols[j+1][0],
        rewardsPerSecond: ((new BigNumber (slaveRewardsPerSecond[j].toString())).times(1e14)).toString(),
        rewardTokenBalance: rewardControllerBalances[j+1].toString(),
        rewardStartBlock: slaveRewardStartBlock[j].toString(),
        isCommunityControl: isCommunityControl[j]
      }
      if(!farmsWithRewardData[i].slaveFarms){
        farmsWithRewardData[i].slaveFarms = []
      }
      farmsWithRewardData[i].slaveFarms.push(newSlave)
    }
  }
  return farmsWithRewardData
}

export default fetchFarmsRewardsData
